import { useEffect, useState } from 'react';
import type { OwnerSession } from '@ai-voice/contracts';
import { getStoredOwnerSession } from './api';
import { OwnerGate } from './components/OwnerGate';
import { OwnerDashboard } from './components/OwnerDashboard';
import { ListenerPanel } from './components/ListenerPanel';
import { modeFromLocation, type AppMode } from './routing';
import { getLanguage, setLanguage, t, type Language } from './i18n';

export default function App() {
  const [mode, setMode] = useState<AppMode>(modeFromLocation());
  const [ownerSession, setOwnerSession] = useState<OwnerSession | null>(getStoredOwnerSession());
  const [language, setLanguageState] = useState<Language>(getLanguage());

  useEffect(() => {
    document.documentElement.lang = language === 'zh' ? 'zh-CN' : language;
  }, [language]);

  function changeLanguage(next: Language): void {
    setLanguage(next);
    setLanguageState(next);
  }

  useEffect(() => {
    const sync = () => setMode(modeFromLocation());
    window.addEventListener('popstate', sync);
    window.addEventListener('hashchange', sync);
    return () => {
      window.removeEventListener('popstate', sync);
      window.removeEventListener('hashchange', sync);
    };
  }, []);

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="brand">
          <span className="brand-mark"><i /><i /><i /></span>
          <span><strong>{t('足球播报语音室')}</strong><small>Football Audio Relay</small></span>
        </div>
        {mode === 'owner' && (
          <nav aria-label={t('当前入口')}>
            <span className="mode-label">{t('主控台')}</span>
          </nav>
        )}
        <div className="top-actions"><label className="language-select"><span>{t('语言')}</span><select value={language} onChange={(event) => changeLanguage(event.target.value as Language)} aria-label={t('语言')}><option value="zh">{t('中文')}</option><option value="en">English</option><option value="ru">Русский</option></select></label></div>
      </header>

      <main>
        {mode === 'listener' ? (
          <ListenerPanel />
        ) : ownerSession ? (
          <OwnerDashboard session={ownerSession} onLogout={() => setOwnerSession(null)} />
        ) : (
          <OwnerGate onAuthenticated={setOwnerSession} />
        )}
      </main>

      <footer>
        <span>{t('每个激活码最多绑定 3 台设备，同一时间仅限 1 台在线。')}</span>
        <strong className="screenshot-warning">{t('请截图保存激活码，遗失不补')}</strong>
      </footer>
    </div>
  );
}